/**
 * Extrae calle / ciudad / provincia y coordenadas de un resultado Nominatim (España).
 * Muchos resultados (pueblo, ciudad, POI) no traen `road`; sin fallback el checklist
 * de perfil no marca Localización aunque el mapa sí se rellene.
 */
export function parseNominatimAddress(location) {
  const address = location?.address || {};
  const lat = parseFloat(location?.lat);
  const lng = parseFloat(location?.lon ?? location?.lng);
  const name = String(location?.name || '').trim();
  const displayHead = String(location?.display_name || '')
    .split(',')[0]
    .trim();

  const calle =
    address.road ||
    address.pedestrian ||
    address.street ||
    address.residential ||
    address.footway ||
    address.path ||
    address.square ||
    address.neighbourhood ||
    address.quarter ||
    address.hamlet ||
    address.building ||
    address.amenity ||
    address.tourism ||
    address.shop ||
    address.leisure ||
    name ||
    displayHead ||
    '';

  const ciudad =
    address.city ||
    address.town ||
    address.village ||
    address.municipality ||
    address.city_district ||
    address.suburb ||
    '';

  const provincia =
    address.province ||
    address.state_district ||
    address.county ||
    address.state ||
    '';

  return {
    localizacion: {
      calle,
      numero: address.house_number || '',
      ciudad,
      provincia,
      codigoPostal: address.postcode || '',
      pais: address.country || 'España',
    },
    lat: Number.isFinite(lat) ? lat : null,
    lng: Number.isFinite(lng) ? lng : null,
  };
}

export function hasProfileCoordinates(d) {
  if (d?.lat == null || d?.lng == null || d.lat === '' || d.lng === '') return false;
  const lat = Number(d.lat);
  const lng = Number(d.lng);
  return Number.isFinite(lat) && Number.isFinite(lng);
}

export function isLocalizacionCompleta(d) {
  return (
    !!d?.localizacion?.calle?.trim() &&
    !!d?.localizacion?.ciudad?.trim() &&
    !!d?.localizacion?.provincia?.trim() &&
    hasProfileCoordinates(d)
  );
}
